import {get, identity} from 'lodash';

const format = require('string-template');

/**
 * @param {string}                           title     - The title of the property
 * @param {Array.<DisplayablePropertyParam>} params    - An array of DisplayablePropertyParam
 * @param {string}                           template  - A string template in which displayable
 *                                                       param names can be rendered
 * @param {string}                           key       - The key of the property
 * @param {boolean}                          raw       - Interpret value as raw (no string format)
 * @param {function(a,b):number}             sorter    - sort-function for table columns
 *
 * @return {Readonly<{DisplayableProperty}>}
 */
export const displayableProperty = ({title, params, template, key, raw, sorter} = {}) =>

  /**
   * @typedef {Object}                            DisplayableProperty
   * @property {string}                           title
   * @property {Array.<DisplayablePropertyParam>} params
   * @property {string}                           template
   * @property {string}                           key
   * @property {boolean}                          raw
   * @property {function(a,b):number}             sorter
   */
  Object.freeze({
    title,
    params,
    template,
    key,
    raw,
    sorter,
    render: (text, record) => {
      const renderRaw = raw || false;
      const renderTemplate = template || '{value}';
      const resolvedParams = params.map((param) => {
        if (!renderTemplate.includes(param.as)) {
          param.as = 'value';
        }

        const transform = (typeof param.transform) === 'function' ? param.transform : identity;

        return {[param.as]: transform(get(record, param.path, ''))};
      });

      const mergedParams = Object.assign(...resolvedParams);

      return {
        props: {},
        children: renderRaw ? mergedParams.value : format(renderTemplate, mergedParams),
      };
    },
  });
